import React from 'react';
import { Navigate } from "react-router-dom";
import { useAuthStore } from "../../store/authStore";

const PublicOnlyRoute = ({ children }) => {
  const { accessToken, user } = useAuthStore();

  if (accessToken) {
    // If logged in, redirect them away from auth pages to their dashboard
    if (user?.role === 'admin' || user?.role === 'super-admin') {
      return <Navigate to="/admins/dashboard" replace />;
    } else if (user?.role === 'hellocian') {
      return <Navigate to="/hellocians/overview" replace />;
    } else {
      return <Navigate to="/clients/dashboard" replace />;
    }
  }

  // If not logged in, render the auth page normally
  return children;
};

export default PublicOnlyRoute;
